module.exports = __webpack_public_path__ + "static/media/comebien_mobile.de83f238.svg";